import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const ProtectedRoute = () => {
  const { isLoading, isAuthenticated, isActive } = useAuth();
  const location = useLocation();

  if (isLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" />;
  if (!isActive && location.pathname !== '/checkout' && location.pathname !== '/account/membership') return <Navigate to="/checkout" />;
  return <Outlet />;
};

export default ProtectedRoute;
